import React from 'react';
import { formatTime } from '../utils/timeFormatters';
import { SessionType } from '../types';
import ProgressRing from './ProgressRing';

interface PomodoroDisplayProps {
  timeLeft: number; // in seconds
  totalTime: number; // total session time in seconds
  sessionType: SessionType;
  isRunning: boolean;
}

const PomodoroDisplay: React.FC<PomodoroDisplayProps> = ({ 
  timeLeft, 
  totalTime, 
  sessionType, 
  isRunning 
}) => {
  const progress = totalTime > 0 ? ((totalTime - timeLeft) / totalTime) * 100 : 0;

  return (
    <div className="flex flex-col items-center justify-center">
      {/* Progress ring with timer */}
      <div className="relative">
        <ProgressRing 
          progress={progress}
          sessionType={sessionType}
          size={320}
          strokeWidth={12}
        />
        
        {/* Timer display overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div 
              className={`
                text-5xl md:text-6xl font-mono font-bold 
                transition-colors duration-300 select-none
                ${isRunning 
                  ? sessionType === SessionType.WORK ? 'text-primary' : 
                    sessionType === SessionType.SHORT_BREAK ? 'text-accent' : 'text-primary'
                  : 'text-text/70'
                }
              `}
            >
              {formatTime(timeLeft)}
            </div>
          </div>
        </div>
      </div>

      {/* Status and progress info below the ring */}
      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6">
        {/* Session status */}
        <div className="flex items-center space-x-2">
          <div 
            className={`
              w-3 h-3 rounded-full transition-colors duration-300
              ${isRunning ? 
                sessionType === SessionType.WORK ? 'bg-primary animate-pulse' : 
                sessionType === SessionType.SHORT_BREAK ? 'bg-accent animate-pulse' : 'bg-primary animate-pulse'
                : 'bg-text/40'
              }
            `}
          />
          <span className="text-lg text-text font-medium">
            {isRunning ? 'Running' : 'Paused'}
          </span>
        </div>

        {/* Progress percentage */}
        <div className="flex items-center space-x-2">
          <div className="text-2xl font-bold text-text">
            {Math.round(progress)}%
          </div>
          <span className="text-lg text-text/60">
            Complete
          </span>
        </div>
      </div>
    </div>
  );
};

export default PomodoroDisplay; 